var _rect, _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTelegram = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#27A5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66193 15.6659C13.5489 13.9724 16.1408 12.856 17.4376 12.3166C21.1404 10.7765 21.9099 10.5089 22.4113 10.5001C22.5216 10.4982 22.7683 10.5255 22.928 10.6551C23.0629 10.7646 23.1 10.9124 23.1178 11.0162C23.1355 11.12 23.1577 11.3564 23.1401 11.5411C22.9394 13.6494 22.0712 18.7657 21.6295 21.1271C21.4426 22.1262 21.0745 22.4613 20.7183 22.494C19.944 22.5653 19.356 21.9823 18.6061 21.4907C17.4326 20.7215 16.7696 20.2426 15.6305 19.492C14.3141 18.6245 15.1675 18.1477 15.9177 17.3685C16.114 17.1646 19.5256 14.0615 19.5916 13.78C19.5999 13.7448 19.6075 13.6136 19.5296 13.5443C19.4516 13.475 19.3365 13.4987 19.2535 13.5175C19.1358 13.5442 17.2611 14.7833 13.6294 17.2348C13.0973 17.6002 12.6153 17.7783 12.1835 17.7689C11.7074 17.7586 10.7916 17.4997 10.1109 17.2785C9.27587 17.007 8.61222 16.8635 8.67001 16.4026C8.70011 16.1625 9.03075 15.9169 9.66193 15.6659Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTelegram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/telegram.65208824.svg";
export { ForwardRef as ReactComponent };